import type { ErrorEvent, EventHint } from "@sentry/react";
import { isChunkLoadError } from "@/shared/utils/chunkLoadError.util";
import { classifyAxiosNoise } from "@/shared/utils/sentryNoise.util";

export function sentryBeforeSend(event: ErrorEvent, hint: EventHint): ErrorEvent | null {
  const originalException = hint.originalException;
  if (isChunkLoadError(originalException)) {
    // Drop entirely — lazyWithRetry / vite:preloadError handler already
    // force-reload on these; users with a stale tab during a deploy
    // are not actionable noise.
    return null;
  }

  const noise = classifyAxiosNoise(originalException);
  if (noise.kind === "drop") return null;
  if (noise.kind === "unchanged") return event;

  event.level = noise.level;
  event.fingerprint = noise.fingerprint;
  // Merged, not replaced: error-handler-service already tags the event with its source.
  event.tags = { ...event.tags, ...noise.tags };
  return event;
}
